<dx-validation-group #validationGroup>
    @if(profileDetails){
        <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
            <div class="card-header fs-5 fw-medium">Supplier Details</div>
            <div class="card-body">
                <div class="row g-3">
                    <div class="col-md-12">
                        <label class="form-label">Supplier</label>
                        <dx-tag-box
                            [(value)]="profileDetails.suppliers"
                            [dataSource]="supplierDataSource"
                            displayExpr="name"
                            valueExpr="id"
                            [searchEnabled]="true"
                            [showClearButton]="true"
                            stylingMode="filled"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-tag-box>
                    </div>
                </div>
            </div>
        </div>
    }
</dx-validation-group>
